import { useParams } from 'react-router-dom';
import { useWalletDetailQuery } from './use-wallet-detail-query.hook';

export function usePolicyDetailsInformation() {
  const { benefitId } = useParams<{ benefitId: string }>();
  const { data, isLoading } = useWalletDetailQuery(undefined, benefitId);

  const policyTab = data?.content_actions?.find(
    ({ name }) => name === 'Policy Information',
  );

  return {
    title: policyTab?.title ?? '',
    description: policyTab?.description ?? '',
    isLoading,
  };
}
